// // const hostname = window.location.hostname;

// // const CONFIG_MAP = {
// //   "localhost": {
// //     ENV_LABEL: "local",
// //     API_BASE_URL: "http://localhost:8095",
// //   },

// // };

// new update karna hai 

// // const config = CONFIG_MAP[hostname] || {
// //   ENV_LABEL: "local",
// //   API_BASE_URL: "http://13.203.130.234:8095",
// // };

// // export default config;

// const config = {
//   // API_BASE_URL: "http://13.203.130.234:8095", // live backend
//   // API_BASE_URL: "https://api.peday.money", // live backend
// API_BASE_URL: "http://127.0.0.1:8095",   // localhost ke liye
// };

// export default config done ;


// config.js


const hostname = window.location.hostname;

const CONFIG_MAP = {
  "localhost": {
    ENV_LABEL: "local",
    API_BASE_URL: "http://localhost:8095",  // local backend
  },
  "13.126.110.172": {
    ENV_LABEL: "aws-server",
    API_BASE_URL: "http://13.203.130.234:8095", // AWS backend
  },
  "lms.peday.money": {
    ENV_LABEL: "prod",
    API_BASE_URL: "https://api.peday.money", // production backend done done  done
  }
};

const config = CONFIG_MAP[hostname] || {
  ENV_LABEL: "default",
  API_BASE_URL: "http://localhost:8095"
};

export default config;
